import JiraTicketStore from '../store/jira-ticket-store';
import { useSnapshot } from 'valtio';
import { createJiraTicket } from '../actions/create-jira-ticket-action';
import { getDependentByProjectFields } from '../actions/get-dependent-by-project-fields-action';
import { getJiraTicketsStatusUpdates } from '../actions/get-jira-tickets-status-updates';
import { getAllSelectableTicketFields } from '../actions/get-selectable-fields-action';
import {
  searchProjects,
  searchAssignee,
  searchReporter,
  searchEpics,
  searchComponents,
} from '../actions/search-actions';
import {
  setDefaultJiraTicketFieldsValues,
  setJiraTicket,
  resetJiraTicketForm,
  setProjects,
  setSelectableTicketFields,
  resetDependentByProjectFields,
  calcValidationObject,
  setValidationObject,
  setLoadingDependentByProjectFields,
  setJiraTicketsStatusUpdates,
} from '../store-actions/jira-ticket-store-actions';

const useJiraStore = () => useSnapshot(JiraTicketStore);
export {
  setDefaultJiraTicketFieldsValues,
  setJiraTicket,
  resetJiraTicketForm,
  setProjects,
  setSelectableTicketFields,
  resetDependentByProjectFields,
  calcValidationObject,
  setValidationObject,
  setLoadingDependentByProjectFields,
  getJiraTicketsStatusUpdates,
  getAllSelectableTicketFields,
  getDependentByProjectFields,
  createJiraTicket,
  searchProjects,
  searchAssignee,
  searchReporter,
  searchEpics,
  searchComponents,
  setJiraTicketsStatusUpdates,
};
export default useJiraStore;
